export default __webpack_public_path__ + "static/media/commerce_mock.56134633.png";